<template>
  <svg
    width="181"
    height="181"
    viewBox="0 0 181 181"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M67.397 166.98V142.417C67.397 142.136 67.6163 141.908 67.8868 141.908H72.234C72.5252 141.908 72.7526 142.167 72.7215 142.468C72.3693 145.872 70.4346 163.752 68.3045 167.251C68.0401 167.686 67.397 167.495 67.397 166.98L67.397 166.98Z"
      fill="#693118"
    />
    <path
      d="M86.5678 166.589L83.2209 141.305C83.181 141.011 82.9361 140.806 82.6739 140.848L78.4607 141.511C78.1785 141.555 77.9949 141.86 78.0678 142.17C78.8921 145.668 83.3046 164.034 85.8657 167.362C86.1836 167.775 86.6407 167.126 86.5678 166.589Z"
      fill="#693118"
    />
    <path
      d="M137.585 58.9828L153.97 59.9275L143.194 63.1133L153.957 68.5683L137.566 71.9441L137.585 58.9828Z"
      fill="#DB8827"
    />
    <path
      d="M16.267 70.2567C16.267 70.2567 11.8006 153.505 81.2599 143.685C99.5115 141.105 111.125 133.106 116.739 127.89C122.354 122.675 140.638 98.1842 141.005 69.4204C141.373 40.6567 132.549 34.9105 121.493 33.1139C110.437 31.3172 101.758 44.2052 100.566 50.1392C99.3732 56.0732 96.4466 86.6868 76.1542 89.9748C47.482 94.6206 16.267 70.2567 16.267 70.2567Z"
      fill="#FAA723"
    />
    <path
      d="M115 60C115.116 60.7181 114.471 62.6259 116.914 64.4409C119.357 66.2559 122.149 65.8035 122.847 65.6904C123.545 65.5773 127.384 62.7443 127.036 60.59C126.687 58.4356 127.339 56.5888 123.5 55C119.661 53.4112 119.28 56.5557 118 57.5C116.72 58.4443 114.768 58.5638 115 60Z"
      fill="white"
    />
    <path
      d="M122.242 65.9315C120.473 66.2183 118.805 65.0153 118.519 63.2446C118.232 61.4739 119.435 59.806 121.205 59.5193C122.974 59.2325 124.642 60.4354 124.928 62.2061C125.215 63.9768 124.012 65.6447 122.242 65.9315Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M118.327 125.286C106.48 137.133 106.485 156.345 118.338 168.198C130.191 180.051 149.403 180.055 161.25 168.209C173.097 156.362 173.092 137.15 161.239 125.297C149.386 113.444 130.174 113.439 118.327 125.286ZM122.582 129.171C112.88 138.874 112.884 154.608 122.591 164.315C132.298 174.022 148.032 174.026 157.734 164.324C167.437 154.622 167.433 138.887 157.726 129.18C148.019 119.473 132.284 119.469 122.582 129.171Z"
      fill="#999999"
    />
    <ellipse
      cx="140.159"
      cy="146.747"
      rx="24.8437"
      ry="24.8563"
      transform="rotate(135 140.159 146.747)"
      fill="#236439"
      fill-opacity="0.23"
    />
    <path
      d="M160.691 149.897C160.692 158.405 145.836 169.849 140.164 165.614C139.104 164.823 140.829 161.989 142.567 162.1C151.26 162.657 155.983 159.769 160.691 149.897Z"
      fill="#CCDBD1"
    />
    <ellipse
      cx="2.35417"
      cy="2.87818"
      rx="2.35417"
      ry="2.87818"
      transform="matrix(-0.353188 0.935552 -0.935418 -0.353543 135.833 162.763)"
      fill="#CCDBD1"
    />
    <path
      d="M127.818 115.652C126.026 110.155 124.544 107.471 122.122 102.5L116.567 104.701C118.878 110.066 120.126 113.095 123.002 118.225C121.778 118.734 121.103 119.054 120.037 120.065C119.942 121.361 120.264 121.956 121.324 122.843L132.622 117.518C133.048 116.054 132.678 115.528 131.705 114.74C130.53 114.639 129.719 114.786 127.818 115.652Z"
      fill="#CCCCCC"
    />
    <rect
      width="8.12017"
      height="33.4516"
      rx="4.06009"
      transform="matrix(-0.917155 0.39853 -0.398846 -0.917018 123.875 103.478)"
      fill="#8C6239"
    />
    <path
      d="M128.608 103.289C128.608 103.289 122.486 100.697 114.749 96.9325C107.011 93.1681 96.1884 79.1505 82.0704 80.0043C67.9523 80.8581 62.4763 91.0648 62.2179 98.2754C61.9594 105.486 67.8566 115.068 79.502 116.981C101.471 120.59 128.608 103.289 128.608 103.289Z"
      fill="#FFC82B"
    />
  </svg>
</template>
